import { render, staticRenderFns } from "./dialog-confirm.vue?vue&type=template&id=52619385&"
import script from "./dialog-confirm.vue?vue&type=script&lang=js&"
export * from "./dialog-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports